<template>
  <a id="download-button" class="download-button" :href="url" download>
    <div class="text">
      <h3>{{filetype}}</h3>
      <p>{{description}}</p>
    </div>
    <img src="../../assets/images/icon-download.svg" alt="ダウンロード">
  </a>
</template>

<script>
export default {
  name: 'DownloadButton',
  props: {
    filetype: { type: String, default: 'SVG' },
    filename: { type: String, default: 'test' }
  },
  data () {
    return {
      description: String,
      descriptions: {
        svg: '拡大しても画質がきれい',
        png: 'デジタルで一般的な画像形式',
        ai: 'イラストレーター専用',
        zip: '全ての形式をまとめて',
        tiff: '印刷に一般的な画像形式'
      }
    }
  },
  created: function () {
    this.description = this.descriptions[this.filetype.toLowerCase()]
  },
  computed: {
    url: function () {
      let type = this.filetype
      if (type === 'TIFF') {
        type = 'tif'
      } else {
        type = type.toLowerCase()
      }
      let imageFile = './static/logos/' + this.filename + '.' + type
      return imageFile
    }
  }
}
</script>

<style scoped>
.download-button, .text {
  display: flex;
  align-items: center;
  flex: 1;
}
a.download-button {
  justify-content: space-between;
  background: var(--lightest-gray);
  padding: 0.8rem 2.4rem;
  box-sizing: border-box;
  border-radius: 0.8rem;
  text-decoration: none;
  color: var(--dim-gray);
  transition: .3s;
}

a.download-button:hover {
  background: var(--honeydew);
  transition: .1s;
}

h3 {
  font-size: var(--normal-font-size);
  margin-right: 1.6rem;
  line-height: 2;
  color: var(--black);
  transition: .3s;
  flex-basis: 4rem;
}

a.download-button:hover h3, a.download-button:hover p {
  color: var(--novasell-green);
  transition: .1s;
}

p {
  font-size: var(--extra-small-font-size);
  letter-spacing: 0;
  flex: 1;
}

img {
  width: 2.4rem;
  height: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/Atoms/DownloadButton.vue